var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ITEM m-b-2:mo"},[_c('p',{staticClass:"text-italic p-b-3"},[_vm._v(_vm._s(_vm.testimonial.quote))]),_c('div',{staticClass:"LINE"}),_c('div',{staticClass:"p-t-2"},[_vm._v(_vm._s(_vm.testimonial.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }